module.exports = __webpack_public_path__ + "img/tws8.79ebef98.png";